(function () {
  if (customElements.get('xray-card')) return;

  class XrayCard extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('.xray-card__media');
      this.toggle = this.querySelector('.xray-card__toggle');

      if (!this.media) return;

      this.addEventListener('click', (event) => {
        if (event.target.closest('.xray-card__button')) return;
        this.classList.toggle('is-flipped');
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          if (event.target.closest('.xray-card__button')) return;
          event.preventDefault();
          this.classList.toggle('is-flipped');
        }
      });
    }
  }

  customElements.define('xray-card', XrayCard);
})();
